import React, { memo } from 'react';
import { View, TouchableOpacity } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { IconStar } from '@redlink/components/atoms';

const RATE_ARRAY = Array.from({ length: 5 });

export const RateView = memo(
  ({
    value = 0,
    starSize = 24,
    onChange,
    editable = false,
    color,
    tintColor,
  }) => {
    const { styles } = useStyle();
    return (
      <View style={styles.container}>
        {RATE_ARRAY.map((_, index) => {
          const isSelected = index <= value - 1;
          return (
            <TouchableOpacity
              style={!isSelected && styles.defaultColor}
              disabled={!editable}
              activeOpacity={0.7}
              onPress={() => onChange(index + 1)}
            >
              <IconStar size={starSize} width={starSize} color={tintColor} />
            </TouchableOpacity>
          );
        })}
      </View>
    );
  }
);

const useStyle = createUseStyle(
  ({ colors, size, shadow, ltrFlexDirection }) => ({
    container: {
      flexDirection: ltrFlexDirection,
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
    defaultColor: {
      opacity: 0.3,
    },
  })
);
